import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import widgets from './modules/widgets'
import search from './modules/search'
import user from './modules/user'
import agency from './modules/agency'
import reports from './modules/reports'
import token from './modules/token'
import adminUser from './modules/adminUser'
import adminMember from './modules/adminMember'
import createPersistedState from 'vuex-persistedstate'
import AES from 'crypto-js/aes'
import Enc from 'crypto-js/enc-utf8'
import { mavKey } from '@/const'
import parameters from './modules/parameters'
import adminInter from './modules/adminInter'
import vehicle from './modules/vehicle'
import vessel from './modules/vessel'
import claims from './modules/claims'
import productManagement from './modules/productManagement'
import promotionManagement from './modules/promotionManagement'
import adminB2c from './modules/adminB2c'
import fire from './modules/fire'
import cargo from './modules/cargo'
import misc from './modules/misc'
import currency from './modules/currency'
import travel from './modules/travel'
import claimParam from './modules/claimParam'
import claimStaging from './modules/claimStaging'
import pa from './modules/pa'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  // strict: false,
  plugins: [
    createPersistedState({
      key: 'maverick',
      storage: window.sessionStorage,
      paths: ['agency', 'claims']
    }),
    createPersistedState({
      key: 'token',
      storage: localStorage,
      paths: ['token'],
      setState: (key, state, storage) => {
        // we will make it harder for pen-tester/hacker
        // This is in no way a make safe option as anything on the client side is readable
        storage.setItem('maverick', AES.encrypt(JSON.stringify(state).toString(), mavKey))
      },
      getState: (key, storage) => {
        const value = storage.getItem('maverick')
        try {
          if (value && value !== 'undefined') {
            const bytes = AES.decrypt(value, mavKey)
            const text = bytes.toString(Enc)
            return JSON.parse(text)
          } else {
            return undefined
          }
        } catch (err) {
          return undefined
        }
      }
    })
  ],
  modules: {
    app,
    widgets,
    search,
    user,
    agency,
    token,
    adminUser,
    adminMember,
    reports,
    parameters,
    adminInter,
    vehicle,
    vessel,
    claims,
    productManagement,
    promotionManagement,
    adminB2c,
    fire,
    cargo,
    misc,
    currency,
    travel,
    claimParam,
    claimStaging,
    pa
  }
})
